
// local urls
// export const MAIN_DOMAIN = `http://taxipoint.test` // local url
// export const SOCKET_URL = window.location.hostname + ':6001' // local url

// dev urls

export const MAIN_DOMAIN = `https://api.taxipoint-backend.dgcars.cloud`//dev url
export const SOCKET_URL = `https://taxipoint-backend.dgcars.cloud:6001` //dev url

// prod urls
// export const MAIN_DOMAIN = `https://api.taxipoint.app` // prod url
// export const SOCKET_URL = `https://socket-api.taxipoint.app` //prod url

export const API = `${MAIN_DOMAIN}/api/V1`
